
import React, { useEffect, useState } from "react";
import { fetchBookingDetails, createOrder, updatePaymentStatus } from "../../services/api";
import WebViewRideDetails from "./WebViewRideDetails";

const RazorpayPayment = () => {
  const [booking, setBooking] = useState(null);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState({ name: "", email: "", contact: "" });
  const [paymentSuccess, setPaymentSuccess] = useState(false);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const bookingId = parseInt(queryParams.get("rideBookingId"));

    if (isNaN(bookingId)) {
      window.AndroidBridge?.onPaymentCancelled?.();
      return;
    }

    // ✅ Wait for Android to inject the JWT into localStorage before fetching.
    // We retry up to ~2 seconds in case injection is slightly delayed.
    let attempts = 0;
    const maxAttempts = 10;

    const fetchBooking = () => {
      const token = localStorage.getItem("authToken");

      if (!token && attempts < maxAttempts) {
        attempts++;
        setTimeout(fetchBooking, 200);
        return;
      }

      fetchBookingDetails(bookingId)
        .then(res => {
          const data = res.data.data;
          setBooking(data);
          setUser({ name: data.name, email: data.email, contact: data.contactNumber });
          setLoading(false);
        })
        .catch(err => {
          console.error("Failed to fetch booking:", err.response?.status, err.response?.data);
          window.AndroidBridge?.onPaymentCancelled?.();
        });
    };

    fetchBooking();
  }, []);

  const startPayment = async () => {
    try {
      const { data } = await createOrder({
        amount: 1, // booking.fare,
        rideBookingId: booking.bookingId
      });

      const options = {
        key: data.key,
        amount: data.amount,
        currency: data.currency,
        name: "Gatiii Booking",
        description: "Ride Payment",
        order_id: data.orderId,
        handler: async function (response) {
          try {
            await updatePaymentStatus({
              orderId: data.orderId,
              paymentId: response.razorpay_payment_id,
              status: "SUCCESS"
            });

            // ✅ Clear injected token so it doesn't linger in WebView storage
            localStorage.removeItem("authToken");

            setTimeout(() => {
              window.AndroidBridge?.onPaymentSuccess?.(response.razorpay_payment_id);
            }, 100);

            setPaymentSuccess(true);
          } catch (e) {
            console.error("Payment status update failed:", e);
            window.AndroidBridge?.onPaymentCancelled?.();
          }
        },
        prefill: {
          name: user.name,
          email: user.email,
          contact: user.contact
        },
        theme: { color: "#3399cc" },
        modal: {
          ondismiss: async function () {
            try {
              await updatePaymentStatus({
                orderId: data.orderId,
                paymentId: null,
                status: "FAILED"
              });
            } catch (e) {
              console.error("Failed to mark payment as failed:", e);
            }

            // ✅ Clear injected token on dismissal too
            localStorage.removeItem("authToken");

            window.AndroidBridge?.onPaymentCancelled?.();
          }
        }
      };

      const razorpay = new window.Razorpay(options);
      razorpay.open();
    } catch (error) {
      console.error("Failed to start payment:", error);
      window.AndroidBridge?.onPaymentCancelled?.();
    }
  };

  if (loading) {
    return (
      <div style={{
        display: "flex", flexDirection: "column", alignItems: "center",
        justifyContent: "center", height: "100vh"
      }}>
        <img
          src="https://cdn.dribbble.com/users/189524/screenshots/12114130/media/ef20bc987e45dc0015159c6dd94a0c1d.gif"
          alt="Loading"
          width="120"
        />
        <h2>Loading Ride Info...</h2>
      </div>
    );
  }

  if (paymentSuccess) {
    return (
      <div style={{
        display: "flex", flexDirection: "column", justifyContent: "center",
        alignItems: "center", height: "100vh", fontFamily: "Arial, sans-serif",
        textAlign: "center", padding: "20px",
      }}>
        <img
          src="https://cdn-icons-png.flaticon.com/512/845/845646.png"
          width="100"
          alt="Success"
          style={{ marginBottom: "20px" }}
        />
        <h2 style={{ color: "#4caf50", marginBottom: "10px" }}>Payment Successful!</h2>
        <p style={{ marginBottom: "30px" }}>Your ride has been confirmed. You will be contacted shortly.</p>
        <button
          onClick={() => window.location.href = "/user-dashboard"}
          style={{
            padding: "12px 24px", backgroundColor: "#1e88e5", color: "#fff",
            border: "none", borderRadius: "8px", fontSize: "16px",
            fontWeight: "bold", cursor: "pointer"
          }}
        >
          Back to Home
        </button>
      </div>
    );
  }

 return (
  <div style={{ padding: "16px", maxWidth: "600px", margin: "auto" }}>
    <WebViewRideDetails booking={booking} />
    <button
      onClick={startPayment}
      style={{
        width: "100%",
        padding: "14px",
        marginTop: "16px",                           // ✅ small gap from ride details
        backgroundColor: "#1e88e5",
        color: "#fff",
        border: "none",
        borderRadius: "12px",
        fontSize: "17px",
        fontWeight: "600",
        cursor: "pointer",
        boxShadow: "0 4px 12px rgba(30, 136, 229, 0.3)",
        transition: "background-color 0.3s ease",
      }}
    >
      Pay ₹{booking.fare}
    </button>
  </div>
);
};

export default RazorpayPayment;